import { render, staticRenderFns } from "./BalanceComponentGroup.vue?vue&type=template&id=0aa46c2a&scoped=true"
import script from "./BalanceComponentGroup.vue?vue&type=script&lang=js"
export * from "./BalanceComponentGroup.vue?vue&type=script&lang=js"
import style0 from "./BalanceComponentGroup.vue?vue&type=style&index=0&id=0aa46c2a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa46c2a",
  null
  
)

export default component.exports